import { ImageIcon } from 'lucide-react'
import { cn } from '../utils/cn'

export function MissingImagePlaceholder({
  className,
  iconClassName,
  title = 'ไม่พบรูปภาพ',
}: {
  className?: string
  iconClassName?: string
  title?: string
}) {
  return (
    <div
      className={cn(
        'flex h-full w-full items-center justify-center bg-aera-lightgray text-aera-lightslate',
        className,
      )}
      title={title}
      aria-label={title}
    >
      <ImageIcon
        className={cn(iconClassName ?? 'h-3.5 w-3.5')}
        aria-hidden
      />
    </div>
  )
}
